import React, { Component } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import {setUser} from '../actions/userActions'
import {Link} from 'react-router-dom'
import {Card, Row, Col, Button, Form} from 'react-bootstrap'
class Login extends Component {
    state = { 
        email: '',
        password: '',
        errorString: ''
     }
     componentDidMount(){
        // Axios.post('https://hosting.breezelabs.co.uk/api/stats/page-visit', {referer: document.referrer ? document.referrer : 'searchbar', site: 'printing - login'})
    }
    updateValue = (e, type) => {
        this.setState({[type]: e.target.value})
    }

    login = () => {
        Axios.post('/api/user/login',{email: this.state.email, password: this.state.password}).then((res)=>{
            if(res.data.success){
                this.props.setUser({user: res.data.user, token: res.data.token})
            }else{
                this.setState({errorString: res.data.error})
            }
        })
    }
    render() { 
                let darkmode = this.props.user ? this.props.user.darkmode : true

        return ( 
                <div style={{width: '100%', marginTop: '60px', marginBottom: '60px'}}>
                    <Card style={{width: '80%',margin: 'auto'}}>
                        <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{textAlign: 'center'}}>
                            <h1>Login</h1>
                        </Card.Header>
                        <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{textAlign: 'center'}}>
                            <Row style={{padding: '20px'}}>
                                <Col xs={4}>
                                <label>Email</label>
                                </Col>
                                <Col xs={6}>
                                    <Form.Control type='text' placeholder='Enter Email' onChange={(e)=>this.updateValue(e,'email')} />
                                </Col>
                                
                            </Row>
                            <Row style={{padding: '20px'}}>
                                <Col xs={4}>
                                    <label>Password</label>

                                </Col>
                                <Col xs={6}>
                                    <Form.Control type='password' placeholder='Enter Password' onChange={(e)=>this.updateValue(e,'password')} />


                                </Col>
                                
                            </Row>
                        </Card.Body>
                        <Card.Footer className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} >
                            <Row >
                                <Col>
                                <Button  type='submit' as={Link} to='/forgot-password'> Forgot Password</Button>
                                </Col>
                                <Col >
                                <Button style={{float: 'right'}}  type='submit'  onClick={this.login}> Login</Button>
                                <p>{this.state.errorString}</p>
                                </Col>
                            </Row>
                                
                            
                        </Card.Footer>
                    </Card>                    
                </div>
         );
    }
}
function mapStateToProps(state){
    return{
        user: state.user
    }
}
function mapDispatchToProps(dispatch){
    return{
        setUser: (data)=>{dispatch(setUser(data))}
    }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(Login);